import { render } from "./smiling.svg?vue&type=template&id=7eadf7d0"
const script = {}
script.render = render

export default script